import dayjs from "dayjs";

export const formatSelectList = (list) => {
  return list.map((v) => {
    return {
      name: v,
      value: v,
    };
  });
};

export const formatTime = (time) => {
  return dayjs(time).format("YYYY-MM-DD");
};

export const formatUnixTime = (time) => {
  return dayjs.unix(time).format("YYYY-MM-DD");
};

export const formatUnixTimeAll = (time) => {
  return dayjs.unix(time).format("YYYY-MM-DD HH:mm:ss");
};

export const getUnixRange = (day) => {
  return `${dayjs().add(-day, "day").unix()},${dayjs().unix()}`;
};
export const formatUnixRange = (start, end) => {
  return `${dayjs(start).unix()},${dayjs(end).unix()}`;
};
export const formatTimeText = (day) => {
  let text = "";
  switch (day) {
    case 7:
      text = "最近7天";
      break;
    case 14:
      text = "最近14天";
      break;
    case 30:
      text = "最近30天";
      break;
  }
  return text;
};

export const formatNums = (num) => {
  console.log(num);

  return num ? num.toFixed(2) : "";
};

export const checkEmptyValue = (list) => {
  return list.some((obj) => {
    return Object.values(obj).some((value) => value === "" || value === null);
  });
};
// 千分位分割函数
export const formatThousand = (num, decimalPlaces = 0) => {
  // 处理空值或非数字情况
  if (num === null || num === undefined || isNaN(Number(num))) {
    return "0" + (decimalPlaces > 0 ? ".".padEnd(decimalPlaces + 1, "0") : "");
  }

  // 将输入转换为数字
  let number = Number(num);

  // 处理小数位数
  number = Number(number.toFixed(decimalPlaces));

  // 分割整数和小数部分
  const parts = number.toString().split(".");
  const integerPart = parts[0];
  const decimalPart = parts.length > 1 ? parts[1] : "";

  // 整数部分添加千分位
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // 组合结果
  if (decimalPlaces > 0) {
    // 确保小数部分长度正确
    const fixedDecimal = decimalPart
      .padEnd(decimalPlaces, "0")
      .slice(0, decimalPlaces);
    return `${formattedInteger}.${fixedDecimal}`;
  }

  return formattedInteger;
};
// 移除千分位格式，返回原始数字
export const parseThousand = (formattedNum) => {
  if (!formattedNum || typeof formattedNum !== "string") {
    return 0;
  }
  // 移除所有逗号后转换为数字
  const cleanNum = formattedNum.replace(/,/g, "");
  return isNaN(Number(cleanNum)) ? 0 : Number(cleanNum);
};
